// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Mobile-only overrides for the Watch Tower shell.
 * Everything here is scoped to max-width 767px, so the desktop layout keeps its fixed sizes.
 */

.trackon-mobile-nav-toggle,
.trackon-nav-backdrop {
  display: none;
}

@media (max-width: 767px) {
  .trackon-mobile-nav-toggle {
    display: inline-flex !important;
  }

  /* The floating Settings button is replaced by a Settings entry in the user menu on phones. */
  .trackon-settings-fab {
    display: none !important;
  }


  /* The sidebar is hidden by default and slides in as an overlay from the header button. */
  .trackon-sider {
    width: 0 !important;
    min-width: 0 !important;
    max-width: 0 !important;
    flex: 0 0 0 !important;
  }

  .trackon-sider--open {
    width: 221px !important;
    min-width: 221px !important;
    max-width: 221px !important;
    flex: 0 0 221px !important;
  }

  .trackon-nav-backdrop--open {
    display: block;
    position: fixed;
    inset: 0;
    z-index: 99;
    background: rgba(0, 0, 0, 0.45);
  }

  .trackon-main {
    margin-left: 0 !important;
  }

  .trackon-header {
    padding: 0 12px !important;
  }

  .trackon-user-meta {
    display: none !important;
  }

  .trackon-content {
    margin: 12px !important;
  }

  /* Wide tables scroll sideways inside the page instead of pushing the whole page wider. */
  .trackon-content .ant-table-wrapper {
    overflow-x: auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/gitsubmodules/trackon/src/styles/trackon-responsive.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF;;EAEE,aAAa;AACf;;AAEA;EACE;IACE,+BAA+B;EACjC;;EAEA,6FAA6F;EAC7F;IACE,wBAAwB;EAC1B;;;EAGA,yFAAyF;EACzF;IACE,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;IACvB,2BAA2B;IAC3B,2BAA2B;IAC3B,0BAA0B;EAC5B;;EAEA;IACE,cAAc;IACd,eAAe;IACf,QAAQ;IACR,WAAW;IACX,+BAA+B;EACjC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,uBAAuB;EACzB;;EAEA,yFAAyF;EACzF;IACE,gBAAgB;EAClB;AACF","sourcesContent":["/*\n * Mobile-only overrides for the Watch Tower shell.\n * Everything here is scoped to max-width 767px, so the desktop layout keeps its fixed sizes.\n */\n\n.trackon-mobile-nav-toggle,\n.trackon-nav-backdrop {\n  display: none;\n}\n\n@media (max-width: 767px) {\n  .trackon-mobile-nav-toggle {\n    display: inline-flex !important;\n  }\n\n  /* The floating Settings button is replaced by a Settings entry in the user menu on phones. */\n  .trackon-settings-fab {\n    display: none !important;\n  }\n\n\n  /* The sidebar is hidden by default and slides in as an overlay from the header button. */\n  .trackon-sider {\n    width: 0 !important;\n    min-width: 0 !important;\n    max-width: 0 !important;\n    flex: 0 0 0 !important;\n  }\n\n  .trackon-sider--open {\n    width: 221px !important;\n    min-width: 221px !important;\n    max-width: 221px !important;\n    flex: 0 0 221px !important;\n  }\n\n  .trackon-nav-backdrop--open {\n    display: block;\n    position: fixed;\n    inset: 0;\n    z-index: 99;\n    background: rgba(0, 0, 0, 0.45);\n  }\n\n  .trackon-main {\n    margin-left: 0 !important;\n  }\n\n  .trackon-header {\n    padding: 0 12px !important;\n  }\n\n  .trackon-user-meta {\n    display: none !important;\n  }\n\n  .trackon-content {\n    margin: 12px !important;\n  }\n\n  /* Wide tables scroll sideways inside the page instead of pushing the whole page wider. */\n  .trackon-content .ant-table-wrapper {\n    overflow-x: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
